import { regex } from './regex';

export const isUrl = (message = 'Must contain a valid url') => regex('url', message);
